import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageInfo {
  title: string;
  subtitle?: string;
  breadcrumbs?: Array<{
    label: string;
    url?: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  private pageInfoSubject = new BehaviorSubject<PageInfo>({
    title: 'Dashboard',
    subtitle: 'Welcome to your dashboard'
  });

  public pageInfo$ = this.pageInfoSubject.asObservable();

  constructor() {}

  setPageInfo(pageInfo: PageInfo): void {
    this.pageInfoSubject.next(pageInfo);
  }

  setTitle(title: string, subtitle?: string): void {
    this.pageInfoSubject.next({
      title,
      subtitle,
      breadcrumbs: this.pageInfoSubject.value.breadcrumbs
    });
  }

  setBreadcrumbs(breadcrumbs: Array<{ label: string; url?: string }>): void {
    this.pageInfoSubject.next({
      ...this.pageInfoSubject.value,
      breadcrumbs
    });
  }

  clearPageInfo(): void {
    this.pageInfoSubject.next({
      title: 'Dashboard',
      subtitle: 'Welcome to your dashboard'
    });
  }
}
